/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  tracker as state
} from '../store';

export default createReducer(state, {
  TOOK_RF_QUIZ: (state, { data: tookRfQuiz }) => ({ ...state, tookRfQuiz }),
  TOOK_MM_QUIZ: (state, { data: tookMmQuiz }) => ({ ...state, tookMmQuiz }),
  TOOK_LM_QUIZ: (state, { data: tookLmQuiz }) => ({ ...state, tookLmQuiz }),
  SET_WHOLE_TRACKER: (state, { data }) => ({ ...state, ...data })
});
